/**
 * Serviço de Histórico de Leads
 * Registra todas as alterações feitas em um lead
 * 
 * Refatorado: Persiste no Supabase ao invés de localStorage
 * Princípios: Single Responsibility, DRY
 */

import { 
    SupabaseOpportunityHistoryRepository, 
    OpportunityHistoryEvent,
    OpportunityHistoryEventType 
} from '../infrastructure/repositories/SupabaseOpportunityHistoryRepository';

export interface LeadHistoryEvent {
    id: string;
    leadId: string;
    type: OpportunityHistoryEventType;
    description: string;
    oldValue?: string;
    newValue?: string;
    timestamp: Date;
    userId?: string;
}

export interface AddEventParams {
    leadId: string;
    organizationId: string;
    type: OpportunityHistoryEventType;
    description: string;
    oldValue?: string;
    newValue?: string;
    userId?: string;
}

class LeadHistoryService {
    /**
     * Adiciona um evento ao histórico de um lead
     * Persiste diretamente no Supabase
     */
    async addEvent(params: AddEventParams): Promise<void> {
        try {
            await SupabaseOpportunityHistoryRepository.addEvent({
                opportunityId: params.leadId,
                organizationId: params.organizationId,
                eventType: params.type,
                description: params.description,
                oldValue: params.oldValue,
                newValue: params.newValue,
                performedBy: params.userId
            });
        } catch (error) {
            console.error('[LeadHistoryService] Failed to add event:', { leadId: params.leadId, type: params.type, error });
            throw error;
        }
    }

    /**
     * Obtém o histórico de um lead do Supabase
     */
    async getLeadHistory(leadId: string): Promise<LeadHistoryEvent[]> {
        const events = await SupabaseOpportunityHistoryRepository.getByOpportunityId(leadId);
        
        return events.map(event => ({
            id: event.id,
            leadId: event.opportunityId,
            type: event.eventType,
            description: event.description,
            oldValue: event.oldValue,
            newValue: event.newValue,
            timestamp: new Date(event.createdAt),
            userId: event.performedBy
        }));
    }

}

// Singleton
export const leadHistoryService = new LeadHistoryService();
